__turbopack_context__.v({
  "active": "Product-module__zj1VFW__active",
  "price": "Product-module__zj1VFW__price",
  "price-wrapper": "Product-module__zj1VFW__price-wrapper",
  "root": "Product-module__zj1VFW__root",
  "strikethrough": "Product-module__zj1VFW__strikethrough",
  "tag": "Product-module__zj1VFW__tag",
  "title": "Product-module__zj1VFW__title",
});
